/** @jsx jsx */
import { jsx } from '@emotion/core'
import { useState, useContext, useEffect, useCallback } from 'react'
import {
  CriteriaRow,
  Title,
  FullHeightSizer,
  Content,
  // Filler,
} from 'core/screen-util'
import MarginAnalysisContext from './MarginAnalysisContext'
import {
  getUnitNameMap,
  getApiTargetInfo,
  getUtilityNameMap,
  getUnits,
  getClientInfo,
  getUserInfo,
  getPnodeZoneEffective,
  isValidYearRange,
  getValidYearRange,
} from 'core'
import {
  SpinContext,
  ErrorContext,
  // UnitSelectionContext,
  PNodeZoneContext,
} from 'context'
import { DatePicker, Button, message, Divider } from 'antd'
import {
  // marginAnalysisExportData,
  // exportData,
  marginAnalysisTrueExportBlob,
} from 'api/pgads'
import { connect } from 'react-redux'
// eslint-disable-next-line no-unused-vars
import moment from 'moment'

import HourlyDetailsModal from './component/HourlyDetailsModal'
// import ExportComponents from 'core/component/ExportComponent'
import { getExportDataHeaders } from './margin-client'
import MarginUtilityUnitSelection from './MarginAnalysisUtilityUnitSelection'
import {
  oaEventTrueUpExportHeadersNRG,
  toXlsxColumns,
  toXlsxData,
  writeToExcel,
} from './Headers'
import { saveAs } from 'file-saver'
import { getFinalData } from './utils'
import { getMarginAnalysisTrueupData } from './api'
import OperationalTruwupLineGraph from './trueup/OptrGraph'
import OperationalTruwupLineGraphPrice from './trueup/TrueupPrices'
import OperationalTruwupLineGraphMWSchedule from './trueup/TrueupMWSchedule'
import EventDataTrueUp from './component/EventDataTrueUp'
import CauseCodeEventTypeBarGraph from './trueup/CauseCodeEventTypeBarGraph'
const MarginAnalysisCommaOpsTrueup = ({
  targetInfo,
  // utilityNameMap,
  // unitNameMap,
  units,
  CLIENT,
  history,
  userInfo,
  pnodeZoneList,
  // eslint-disable-next-line no-unused-vars
  unitNameMap,
  ...props
}) => {
  const title = 'Margin Analysis Trueup'
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  // const { userInfo } = useContext(ClientContext)
  const { unitIdEmktIdMap, getMarginUnitCode } = useContext(PNodeZoneContext)

  const {
    setScenarioList,
    setRetrievedData,
    setWFRetrievedData,
    reloadScenario,
    setSelectedScenario,
    selectedDateRangePicker,
    setSelectedDateRagePicker,
    unitSelection,
    setUnitSelection,
    handlerRetrieveData,
    lostType,

    ...marginContext
  } = useContext(MarginAnalysisContext)

  const retrievedData = getFinalData(marginContext, false)

  // const [isRetrieved, setIsRetrieved] = useState(false)

  const [trueUpCoreResponse, setTrueUpCoreResponse] = useState({})
  const clearData = _ => {
    setRetrievedData({})
    setWFRetrievedData({})
    setTrueUpCoreResponse({})
    // setSelectedScenario({})
  }

  const [showHourlyDetails, setShowHourlyDetails] = useState(false)

  const retrieveData = _ => {
    if (unitSelection.length === 0) {
      message.warning('Please, Select Unit')
      return
    }
    if (selectedDateRangePicker.length <= 0) {
      message.warning('Please, Select Date Range')
      return
    }

    const isValid = isValidYearRange(
      props.validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) return

    const utility = unitSelection[0]
    const unit = getMarginUnitCode(unitSelection[1])
    const emktId = unitIdEmktIdMap[unitSelection[1]] || 'tempEmktId'
    // scenario: {},

    const reqData = {
      mode: 'NORMAL',
      startDate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      endDate: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      utility,
      unit,
      emktId,
      // scenario: {},
      showCauseCode: false,
      lostType,
      scenario: {
        scenarioName: 'True up',
        author: userInfo.userName,
        utility,
        unit,
        unitId: emktId,
        unitid: emktId,
        emktId,
        startdate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
        enddate: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      },
    }

    setSpinning(true)
    const retrieveDataFunc = getMarginAnalysisTrueupData

    retrieveDataFunc(targetInfo)(reqData).fork(
      error => {
        setError(error)
        handlerRetrieveData({}, _ => _)
        clearData()
      },
      data => {
        setSpinning(false)

        const { marginResponse, trueUpCoreResponse } = data
        const { hourlyDataTrueup } = trueUpCoreResponse
        const finaldata = {
          ...marginResponse,
          hourlyDetailsData: hourlyDataTrueup,
          hourlyExportData: hourlyDataTrueup,
        }
        //         setRetrievedData(finaldata)
        setTrueUpCoreResponse(trueUpCoreResponse)

        handlerRetrieveData(finaldata, _ => _)
      }
    )
  }

  useEffect(
    _ => {
      // setSelectedDateRagePicker([moment('20180101'), moment('20180103')])
      reloadScenario(targetInfo)
    },
    [setError, targetInfo, setScenarioList, reloadScenario]
  )

  const exportMarginData = _ => {
    const selUnit = units.find(u => u.unitId === unitSelection[1])

    // marginAnalysisExportData(targetInfo)(retrievedData).fork(setError, res => {
    //   setSpinning(false)
    //   exportData(res, 'application/pdf', 'ma')
    // })

    const sd = `${selectedDateRangePicker[0].format('YYYY-MMM-DD')}`
    const ed = `${selectedDateRangePicker[1].format('YYYY-MMM-DD')}`
    const fileNAme =
      'ma-' +
      (selUnit || { unitName: '' }).unitName +
      '-' +
      sd +
      '_' +
      ed +
      '.pdf'

    setSpinning(true)
    marginAnalysisTrueExportBlob(targetInfo)(
      { marginResponse: retrievedData, trueUpCoreResponse: trueUpCoreResponse },
      {},
      fileNAme
    )(_ => setSpinning(false))
  }

  const exportData = async _ => {
    const { hourlyExportData = [] } = retrievedData
    const exportHeader = getExportDataHeaders(CLIENT, true)

    const columns = toXlsxColumns(exportHeader)
    setSpinning(true)

    const ed = toXlsxData(hourlyExportData, exportHeader)

    const worksheet = [
      {
        // name: 'sheet1',
        columns,
        data: ed,
        metaInfo: [],
        colorInfo: [],
      },
    ]

    const fileBlob = await writeToExcel(worksheet)
    setSpinning(false)
    saveAs(fileBlob, 'ma-hours')
  }

  const exportEventData = async _ => {
    const { exportEvents = [] } = trueUpCoreResponse
    const exportHeader = oaEventTrueUpExportHeadersNRG

    const columns = toXlsxColumns(exportHeader)
    setSpinning(true)

    const ed = toXlsxData(exportEvents, exportHeader)

    const worksheet = [
      {
        name: `ma-${
          unitNameMap[unitSelection[1]]
        }-${selectedDateRangePicker[0].format(
          'yyyy-MMM-DD'
        )}_${selectedDateRangePicker[1].format('YYYY-MMM-DD')}`,
        columns,
        data: ed,
        metaInfo: [],
        colorInfo: [],
      },
    ]

    const fileBlob = await writeToExcel(worksheet)
    setSpinning(false)
    saveAs(fileBlob, 'ma-events')
  }

  const showHourlyDialog = _ => {
    setShowHourlyDetails(true)
  }

  const whatif = _ => {
    // const selUnit = units.find(u => u.unitId === unitSelection[1])
    if (!unitIdEmktIdMap[unitSelection[1]]) {
      message.warning('ID not found')
      return
    }
    const newScnerio = {
      isNew: true,
      scenarioName: '*New Scenario',
      startdate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      enddate: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      author: userInfo.userName,
      utility: unitSelection[0],
      unit: getMarginUnitCode(unitSelection[1]),
      unitId: unitIdEmktIdMap[unitSelection[1]],
      unitid: unitIdEmktIdMap[unitSelection[1]],
    }

    setSelectedScenario(newScnerio)
    setWFRetrievedData({
      ...retrievedData,
      request: {
        ...retrievedData.request,
        mode: 'WHATIF',
        scenario: newScnerio,
      },
    })

    history.push({ pathname: '/marginanalysiswhatif' })
  }

  const getUnitNameId = id => {
    const rolId = pnodeZoneList.find(
      u => '' + u.utility + u.rollupEmktid === id
    )
    if (rolId) {
      return '' + rolId.utility + rolId.unit
    }
    return id
  }

  const graphHeight = 250
  const getGraphWidth = useCallback(width => width / 2 - 50, [])

  return (
    <div>
      <CriteriaRow
        style={{
          overflowY: 'hidden',
          overflowX: 'auto',
          display: 'flex',
          flexWrap: 'wrap',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '250px 650px auto',
            width: '100%',
          }}
        >
          <Title
            css={{
              marginRight: '5px',
              marginBottom: '5px',
              minWidth: 300,
            }}
          >
            {title}
          </Title>
          <div>
            <div
              style={{ display: 'grid', gridTemplateColumns: '400px 300px' }}
            >
              <MarginUtilityUnitSelection
                defaultValue={unitSelection}
                utility={unitSelection[0]}
                unit={unitSelection[1]}
                onUnitChange={value => {
                  setUnitSelection(value)

                  clearData()
                }}
                style={{ width: '400px' }}
              />

              <DatePicker.RangePicker
                style={{ marginLeft: '15px', width: '230px' }}
                allowClear={false}
                format="MMM/DD/YYYY"
                value={selectedDateRangePicker}
                onChange={d => {
                  setSelectedDateRagePicker([
                    d[0]
                      .clone()
                      .set('hour', 0)
                      .minute(0)
                      .second(0)
                      .millisecond(0),
                    d[1]
                      .clone()
                      .set('hour', 0)
                      .add(1, 'd')
                      .subtract(1, 'hours')
                      .minute(0)
                      .second(0)
                      .millisecond(0),
                  ])
                  clearData()
                }}
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              // flexFlow: 'column',
              gap: '5px',
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            <Button
              onClick={retrieveData}
              type="primary"
              style={{ marginLeft: '5px' }}
            >
              Retrieve
            </Button>

            <Button
              onClick={showHourlyDialog}
              type="primary"
              style={{ marginLeft: '5px' }}
              disabled={!retrievedData.dls}
            >
              Hourly Detail
            </Button>

            <Button
              onClick={whatif}
              type="danger"
              style={{ marginLeft: '5px' }}
              disabled={!retrievedData.dls}
            >
              What If Scenario
            </Button>

            <Button
              onClick={exportMarginData}
              icon="export"
              type="dashed"
              style={{ marginLeft: '5px' }}
              disabled={!retrievedData.dls}
            >
              Export to PDF
            </Button>
            <Button
              onClick={exportData}
              icon="export"
              type="dashed"
              style={{ marginLeft: '5px' }}
              disabled={!retrievedData.dls}
            >
              Export Hourly Data
            </Button>

            <Button
              onClick={exportEventData}
              icon="export"
              type="dashed"
              style={{ marginLeft: '5px' }}
              disabled={!retrievedData.dls}
            >
              Export Event Data
            </Button>
          </div>
        </div>
      </CriteriaRow>

      {showHourlyDetails && (
        <HourlyDetailsModal
          visible={showHourlyDetails}
          setClose={_ => setShowHourlyDetails(false)}
          unitId={getUnitNameId(unitSelection[1])}
          trueup
        />
      )}

      <FullHeightSizer heightOffset={220}>
        {({ height, width }) => {
          return (
            <Content
              style={{
                height: height + 20,
                display: 'grid',
                gridTemplateColumns: '50% 20px 45%',
                gap: '5px',
                overflowY: 'auto',
              }}
            >
              <CauseCodeEventTypeBarGraph
                data={trueUpCoreResponse.exportEvents || []}
                actualHeight={graphHeight}
                actualWidth={getGraphWidth(width)}
              />
              <Divider
                style={{ gridRowEnd: 'span 2', height: '100%', margin: '5px' }}
                type="vertical"
              />
              <OperationalTruwupLineGraph
                height={graphHeight}
                width={getGraphWidth(width)}
                tdata={trueUpCoreResponse}
                startDate={
                  selectedDateRangePicker[0]
                    ? selectedDateRangePicker[0]
                    : undefined
                }
                endDate={
                  selectedDateRangePicker[1]
                    ? selectedDateRangePicker[1]
                    : undefined
                }
              />
              <Divider style={{ gridColumnEnd: 'span 3', margin: '5px' }} />
              <OperationalTruwupLineGraphPrice
                height={graphHeight}
                width={getGraphWidth(width)}
                tdata={trueUpCoreResponse}
                startDate={
                  selectedDateRangePicker[0]
                    ? selectedDateRangePicker[0]
                    : undefined
                }
                endDate={
                  selectedDateRangePicker[1]
                    ? selectedDateRangePicker[1]
                    : undefined
                }
              />
              <Divider
                style={{ gridRowEnd: 'span 3', height: '100%', margin: '5px' }}
                type="vertical"
              />
              <OperationalTruwupLineGraphMWSchedule
                height={graphHeight}
                width={getGraphWidth(width)}
                tdata={trueUpCoreResponse}
                startDate={
                  selectedDateRangePicker[0]
                    ? selectedDateRangePicker[0]
                    : undefined
                }
                endDate={
                  selectedDateRangePicker[1]
                    ? selectedDateRangePicker[1]
                    : undefined
                }
              />
              <Divider style={{ gridColumnEnd: 'span 3', margin: '5px' }} />
              <div
                style={{
                  gridColumnEnd: 'span 2',
                  // border: '1px solid black',
                }}
              >
                <EventDataTrueUp
                  height={height - graphHeight * 2 - 50}
                  width={width - 50}
                  CLIENT={CLIENT}
                  events={trueUpCoreResponse.exportEvents || []}
                />
              </div>
            </Content>
          )
        }}
      </FullHeightSizer>
    </div>
  )
}

// const MarginAnalysisContextComponent = props => (
//   <MarginAnalysisProvider>
//     <MarginAnalysis {...props} />
//   </MarginAnalysisProvider>
// )

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  units: getUnits(state),
  targetInfo: getApiTargetInfo(state),
  CLIENT: getClientInfo(state),
  userInfo: getUserInfo(state),
  pnodeZoneList: getPnodeZoneEffective(state),
  validYearRange: getValidYearRange(state),
})
export default connect(mapStateToProps)(MarginAnalysisCommaOpsTrueup)
